import React from 'react';

import cookie from 'js-cookie';
import Fetch from 'whatwg-fetch';
import Moment from 'moment';
import MomentLocale from 'moment/locale/sk';

import UserPanel from './app/UserPanel.jsx';
import ContentManagerContainer from './app/ContentManagerContainer.jsx';
import ContentManagerAdminContainer from './app/ContentManagerAdminContainer.jsx';

import kosiceonlinePic from '../images/kosice-online.png';
import radiokosicePic from '../images/radio-ke.png';
import detskePic from '../images/detske-radio.png';

import { valueForKeyPath as v } from './utils.jsx';

require('../css/app.css');
require('font-awesome-webpack');

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      access_token: null,
      user: null,
      contentspace: null,
      user_logged: false,
      contentspace_info: null,
      user_is_cs_admin: false,
      admin_content: false,
    };

    this.setAdminContent = this.setAdminContent.bind(this);
  }

  getUserInfo(access_token) {
    // loadneme usera
    // /api/oauth2/user
    fetch('/api/cm/cmprofile', {
      method: 'get',
      headers: {
        Authorization: 'Bearer ' + access_token,
      },
    })
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          return response.json();
        } else {
          var error = new Error(response.statusText);
          error.response = response;
          error.status_code = response.status;
          throw error;
        }
      })
      .then(userinfo => {
        let cs_info = userinfo.contentspace_info;
        cs_info['is_contentspace_admin'] =
          userinfo.contentspace_info.user.is_admin;
        this.setState({
          user: cs_info.user,
          user_logged: true,
          contentspace_info: cs_info,
          user_is_cs_admin: userinfo.contentspace_info.user.is_admin,
          contentspace: userinfo.contentspace_info._id,
        });
      })
      .catch(error => {
        cookie.remove('access_token');
        this.setState({
          access_token: null,
          user: null,
          contentspace: null,
          contentspace_info: null,
        });
        if (error.status_code === 404) {
          alert('Nemate prístup k manažérovi obsahu.');
        } else {
          error.response.json().then(json => {
            console.error(error);
            let message = json.description;
            if (message === 'None') {
              message =
                'Pri prihlasovaní sa do manažéra nastala neočakávaná chyba';
            }
            alert(message);
          });
        }
      });
  }

  logout() {
    this.setState({
      access_token: null,
      user: null,
    });
    cookie.remove('access_token', { path: '/' });
    //window.location.reload();
    window.location = '/';
  }

  parseQS(qs) {
    let params = qs.split('&');
    let parsed = {};
    for (let p of params) {
      let pp = p.split('=');
      parsed[decodeURIComponent(pp[0])] = decodeURIComponent(pp[1]);
    }
    return parsed;
  }

  componentWillMount() {
    // kukol na cookies, nastavil access_token do state
    // ziskal requestom info o tokene = user > nasetujem usera
    let access_token = cookie.get('access_token');
    this.setState({
      access_token: access_token,
    });
    if (access_token) {
      this.getUserInfo(access_token);
    } else {
      let hash = window.location.hash;

      if (hash) {
        let params = this.parseQS(hash.substr(1));
        if (params.access_token) {
          window.location.hash = '!';
          this.setState({
            access_token: params.access_token,
          });
          cookie.set('access_token', params.access_token, {
            path: '/',
          });
          this.getUserInfo(params.access_token);
        } else {
          if (params.error === 'forbidden') {
            alert('Nemáte prístup k manažérovi obsahu');
          }
        }
      }
    }
  }

  setAdminContent(set) {
    if (set) {
      this.setState({ admin_content: true });
    } else {
      this.setState({ admin_content: false });
    }
  }

  render() {
    const content = () => {
      if (this.state.user_logged && this.state.contentspace_info) {
        let page_content;
        if (this.state.admin_content) {
          page_content = (
            <ContentManagerAdminContainer
              contentspace={this.state.contentspace}
              contentspace_info={this.state.contentspace_info}
              access_token={this.state.access_token}
              user={this.state.user}
              api_endpoint={'/api/cm'}
            />
          );
        } else {
          page_content = (
            <ContentManagerContainer
              isMediaBrowser={this.props.isMediaBrowser}
              access_token={this.state.access_token}
              key="ContentManagerContainer"
              contentspace={this.state.contentspace_info._id}
              contentspace_info={this.state.contentspace_info}
              previewUrl={this.state.contentspace_info.previewUrl}
              api_endpoint={'/api/cm'}
              defaultAuthorName={v(this.state.user, 'display_name')}
            />
          );
        }

        return (
          <div>
            <UserPanel
              appname="Content Manager"
              admin_content={this.state.admin_content}
              user_is_cs_admin={this.state.user_is_cs_admin}
              user={this.state.user}
              contentspace_info={this.state.contentspace_info}
              key="UserPanel"
              logout={this.logout.bind(this)}
              setAdminContent={this.setAdminContent}
            />
            {page_content}
          </div>
        );
      } else if (this.state.access_token) {
        return <div className="loader">loading...</div>;
      } else {
        return (
          <div style={{}}>
            <div className="jumbotron">
              <h1>Prihlásenie</h1>
              <p>Prihláste sa do aplikácie správy obsahu</p>
              <div className="row">
                <div className="col-sm-12 col-md-4">
                  <a
                    className="btn btn-default"
                    href={this.props.loginUrl + 'kosiceonline'}
                  >
                    <img src={kosiceonlinePic} style={{ width: '100%' }} />
                    <br />
                    <span style={{ color: 'red', float: 'right' }}>
                      www.kosiceonline.sk
                    </span>
                  </a>
                </div>
                <div className="col-sm-12 col-md-4">
                  <a
                    className="btn btn-default"
                    href={this.props.loginUrl + 'radiokosice'}
                  >
                    <img src={radiokosicePic} style={{ width: '100%' }} />
                    <br />
                    <span style={{ color: 'red', float: 'right' }}>
                      www.radiokosice.sk
                    </span>
                  </a>
                </div>
                <div className="col-sm-12 col-md-4">
                  <a
                    className="btn btn-default"
                    href={this.props.loginUrl + 'detskeradio'}
                  >
                    <img src={detskePic} style={{ width: '100%' }} />
                    <br />
                    <span style={{ color: 'red', float: 'right' }}>
                      www.detske.radio
                    </span>
                  </a>
                </div>
                <div className="col-sm-12 col-md-4">
                  <a
                    className="btn btn-default"
                    href={this.props.loginUrl + 'dopravnyservis'}
                  >
                    <img src={radiokosicePic} style={{ width: '100%' }} />
                    <br />
                    <span style={{ color: 'red', float: 'right' }}>
                      dopravný servis
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        );
      }
    };
    return (
      <div className="container container-fluid">
        <br />
        <br />
        {content()}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/js/app.jsx